import { Progress } from "@/components/ui/progress"
import type { ChallengeActivity } from "@/services/api/odin/activities/challenge/study-session/update"
import { X } from "lucide-react"

interface ChallengeHeaderProps {
  courseName: string
  activityName: string
  activity: ChallengeActivity
  onClose: () => void
}

export default function ChallengeHeader({
  activity,
  courseName,
  activityName,
  onClose,
}: ChallengeHeaderProps) {
  const progress = (activity.current / activity.total) * 100
  return (
    <div className="flex h-fit w-full flex-col gap-2">
      <div className="flex w-full justify-end">
        <X className="cursor-pointer text-neutral-500 hover:text-neutral-700" onClick={onClose} />
      </div>
      <div className="flex w-full">
        <Progress value={progress} className="mb-2 h-3 bg-neutral-200" />
      </div>
      <div className="flex items-center justify-between gap-2 px-1 text-sm text-neutral-700">
        <div className="flex gap-1">
          <strong>{courseName}:</strong> {activityName}
        </div>
        <div className="border-1 text-md flex items-center gap-2 rounded-lg border border-primary-100 bg-primary-50 px-4 py-2 font-medium text-primary-700">
          <span className="flex items-center gap-1">
            <span className="font-semibold">Pregunta:</span>
            <span>
              {activity.current}/{activity.total}
            </span>
          </span>
        </div>
      </div>
    </div>
  )
}
